import { render, staticRenderFns } from "./EmailCampaignModal.vue?vue&type=template&id=2bdeeb3d&scoped=true"
import script from "./EmailCampaignModal.vue?vue&type=script&lang=js"
export * from "./EmailCampaignModal.vue?vue&type=script&lang=js"
import style0 from "./EmailCampaignModal.vue?vue&type=style&index=0&id=2bdeeb3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdeeb3d",
  null
  
)

export default component.exports